import React, { useCallback, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import FbHeader from '../component/FbHeader'
import { FoodOfferCard } from '../component/FoodOfferCard';
import foodOfferImg from "../../../assets/food/foodofferimg.png"
import CountdownTimer from '../component/CountdownTimer';
import * as appConstants from "../../../constants/index";
import SweetAlertUtility from '../component/SweetAlertUtility';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { formatExpiryDate } from '../component/commonFunction';

const FoodCart = () => {
    const navigate = useNavigate();

    const [alertDetails, setAlertDetails] = useState({ show: false, type: '', title: '', message: '' });
    const theatreId = JSON.parse(localStorage.getItem("TheatreId"));
    const [offerCards, setOfferCards] = useState((JSON.parse(localStorage.getItem("cartOffers")) || []).filter(item => item.type === "addtocart" && item.theatreId === theatreId));
    const [isClosing, setIsClosing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [prepareMultiOrderStatus, setPrepareMultiOrderStatus] = useState([]);

    const AuthToken = sessionStorage.getItem("token") || " ";
    const theme = localStorage.getItem("theme");
    const city = localStorage.getItem("city");
    const cartCapacity = JSON.parse(localStorage.getItem("cartCapacity")) || [];
    const maxActivateLimit = JSON.parse(localStorage.getItem("maxActivateLimit")) || [];
    const storeAllOfferData = JSON.parse(localStorage.getItem("storeAllOfferData")) || [];

    localStorage.setItem("promBanner", false);
    localStorage.setItem("pageName", "offercart");

    const handleRemoveOffer = (offerId) => {
        setOfferCards((prevOffers) => {
            const updatedOffers = prevOffers.filter(offer => offer.voucherId !== offerId);
            localStorage.setItem("cartOffers", JSON.stringify(updatedOffers));
            return updatedOffers;
        });
    };

    const fetchActivate = async () => {
        const voucherIds = offerCards?.map(item => item?.voucherId);
        if (!offerCards) {
            sweetAlertWarning("Item not found");
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(
                `${appConstants.base_url}v1/jito/activate-voucher`,
                {
                    ccode: theatreId,
                    vouId: voucherIds
                },
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        city: city
                    }
                }
            );

            if (response.data.result.toLowerCase() === "success") {
                let newOffers = response.data.output.filter(item => item.voucherNo);

                // debugger
                const selectedTheater = JSON.parse(localStorage.getItem("selectedTheater")) || [];


                // const updatedNewOffers = newOffers.map(offer => ({
                //     ...offer,
                //     ...(match ? {
                //         howToAvail: match.howToAvail || [],
                //         termCondition: match.termCondition || [],
                //         rules: match.rules || []
                //     } : {}),
                //     expiryDate: formatExpiryDate(offer.expiryDate),
                //     activatedDate: formatExpiryDate(offer.activatedDate),
                //     theatreId: parseInt(selectedTheater.theatreId),
                //     theatreName: selectedTheater.name
                // }));

                const updatedNewOffers = newOffers.map(offer => {
                    // const match = offerCards.find(c => c.voucherId === offer.voucherId);
                    const match = offerCards.find(
                        c => c.voucherId === offer.voucherId && c.theatreId === parseInt(selectedTheater.theatreId, 10)
                    );

                    return {
                        ...offer,
                        // Merge additional fields from offerCards (only if found)
                        ...(match ? {
                            howToAvail: match.howToAvail || [],
                            termCondition: match.termCondition || [],
                            rules: match.rules || []
                        } : {}),

                        // Format dates and add theatre info
                        expiryDate: formatExpiryDate(offer.expiryDate),
                        activatedDate: formatExpiryDate(offer.activatedDate),
                        theatreId: parseInt(selectedTheater.theatreId, 10),
                        theatreName: selectedTheater.name
                    };
                });

                const mergedOffers = [
                    ...storeAllOfferData,
                    ...updatedNewOffers.filter(
                        newItem => !storeAllOfferData.some(existingItem => existingItem.voucherNo === newItem.voucherNo && newItem.theatreId === theatreId)
                    )
                ];
                localStorage.setItem("FoodActivated", JSON.stringify(updatedNewOffers));
                localStorage.setItem("storeAllOfferData", JSON.stringify(mergedOffers));
                navigate("/offeractivated")
            } else {
                sweetAlertWarning(response?.data?.msg);
            }
        } catch (error) {
            console.error("Error activating offer:", error);
            sweetAlertError("Failed to activate offer. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleAddMore = () => {
        if (offerCards.length >= cartCapacity) {
            sweetAlertWarning(`Maximum limit reached for this cinema.`);
            setShow(false);
            setIsClosing(false);
            return;
        }
        navigate("/food-Vouchers-at-boxoffice");
    }

    // const handleActivate = () => {
    //     const totalActive = storeAllOfferData.length + offerCards.length;
    //     if (totalActive > maxActivateLimit) {
    //         sweetAlertWarning(`Maximum voucher activation limit reached.`);
    //         return;
    //     }

    //     fetchActivate();
    // };

    const handleActivate = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${appConstants.base_url}v1/jito/active-voucher-count`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        city: city
                    }
                }
            );

            if (response.data.result.toLowerCase() === "success") {
                const totalActive = storeAllOfferData.length + offerCards.length;
                if (response.data.output >= maxActivateLimit || totalActive > maxActivateLimit) {
                    sweetAlertWarning(`Maximum voucher activation limit reached.`);
                    return;
                }
                fetchActivate();
            } else {
                sweetAlertError(response?.data?.msg);
            }
        } catch (error) {
            console.error("Error activating offer:", error);
            sweetAlertError("Failed to activate offer. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const sweetAlertError = (msg) => {
        setAlertDetails({
            show: true,
            type: 'error',
            title: 'Error!',
            message: msg,
        });
    };
    const sweetAlertWarning = (msg) => {
        setAlertDetails({
            show: true,
            type: 'warning',
            title: '',
            message: msg,
        });
    };

    const hideAlert = () => {
        setAlertDetails({ show: false });
    }

    const handleImageError = (e) => {
        e.target.src = noImg;
    };

    const handleHide = () => {
        setIsClosing(false);
    };

    // const handleConfirm = () => {
    //     setIsClosing(false);
    //     const storedOffers = JSON.parse(localStorage.getItem("cartOffers")) || [];
    //     const remainingOffers = storedOffers.filter(item => item.type !== "addtocart");
    //     localStorage.setItem("cartOffers", JSON.stringify(remainingOffers));
    //     setOfferCards(remainingOffers.filter(item => item.type === "addtocart"));
    // };

    const handleConfirm = () => {
        setIsClosing(false);
        const storedOffers = JSON.parse(localStorage.getItem("cartOffers")) || [];
        const updatedOffers = storedOffers.filter(item => !(item.type === "addtocart" && item.theatreId === theatreId));

        localStorage.setItem("cartOffers", JSON.stringify(updatedOffers));
        const currentTheatreOffers = updatedOffers.filter(item => item.theatreId === theatreId && item.type === "addtocart");

        setOfferCards(currentTheatreOffers);
    };


    const handleClearCart = () => {
        setIsClosing(true);
    }


    const updateOrders = useCallback(() => {
        const currentTime = Date.now();
        const storedOrders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

        const updatedOrders = storedOrders.map(order => {
            const isFoodItem = order?.foodItems?.length > 0;
            const isVoucherItem = order?.activateVoucher?.length > 0;

            const activeVouchers = (order.activateVoucher || []).filter(voucher =>
                new Date(voucher.expiryDate).getTime() > currentTime
            );

            return {
                ...order,
                activateVoucher: activeVouchers.length > 0 ? activeVouchers : null,
                isFoodItem,
                isVoucherItem
            };
        }).filter(order =>
            (order.isVoucherItem && order.activateVoucher?.length > 0) ||
            (order.isFoodItem && order.foodItems?.length > 0)
        );

        localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));
        setPrepareMultiOrderStatus(updatedOrders);
    }, []);


    useEffect(() => {
        updateOrders();
        const ordersInterval = setInterval(updateOrders, 10_000);
        return () => clearInterval(ordersInterval);
    }, [updateOrders]);

    const handleOfferActivated = (timerId) => {
        localStorage.setItem("timerId", JSON.stringify(timerId));
        navigate("/offeractivated");
    };
    const filteredVouchers = [];

    const filteredOrders = prepareMultiOrderStatus.filter((item) => {
        if (!item.storeAllOfferData || !item.activateVoucher?.length) return false;

        const vouchersForTheatre = item.activateVoucher.filter(
            (v) => v.theatreId === theatreId
        );

        if (vouchersForTheatre.length > 0) {
            filteredVouchers.push(...vouchersForTheatre); // collect for later use
            return true; // keep this item in filteredOrders
        }

        return false;
    });
    // console.log(filteredOrders)
    return (
        <>
            <FbHeader className="inrHdrPage cartmenu" headname="Your Cart" addressShow={false} cartData={offerCards.filter(item => item.theatreId === theatreId)} handleClearCart={handleClearCart} />
            <div className='crtInfo'>
                {offerCards.filter(item => item.theatreId === theatreId).length > 0 && (
                    <>
                        <span>{offerCards.filter(item => item.theatreId === theatreId).length} Offer{offerCards.filter(item => item.theatreId === theatreId).length > 1 ? "s" : ""} in cart</span>
                        {filteredVouchers.length > 0 && <span className='bulletcrt'></span>}
                    </>
                )}
                {filteredVouchers.length > 0 && (
                    <>
                        <span className='actofrTxt' onClick={() => handleOfferActivated(filteredOrders[0]?.en_bid)}>
                            Click to see Activated Offers!
                        </span>
                        {/* <span className='actofrTxt' onClick={() => handleOfferActivated(filteredOrders[0]?.en_bid)}>
                            {offerCards.filter(item => item.theatreId === theatreId).length > 0 ? `${filteredVouchers.length} Active Offers` : "Click to see activated offers!"}
                        </span> */}
                        {/* <span className='actofrTxt' onClick={() => handleOfferActivated(filteredOrders[0]?.en_bid)}>
                            {filteredVouchers.length} Active Offer{filteredVouchers.length > 1 ? 's' : ''}
                        </span> */}
                    </>
                )}
            </div>
            <div className='FoodCartPage contentPage pb100' style={(offerCards.length > 0 || filteredOrders.length > 0) ? { paddingTop: 20 } : {}}>
                <section className='foodCard p0'>
                    {offerCards?.length > 0 ? (
                        <>
                            <FoodOfferCard
                                // key={item.voucherId}
                                // id={item.voucherId}
                                // link={`/redeem-offers/${item?.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase()}`}
                                // image={item.voucherImageUrl}
                                // title={item.voucherDesc}
                                // validity={item.validTill}
                                className="crtPdge"
                                removeLink="Remove"
                                data={offerCards}
                                onRemove={handleRemoveOffer}
                                cartPage={false}
                            />
                            <div className="fixbtmbtn modalbtnCon">
                                <p className='notedc expTag'><span>Note:</span> Expired vouchers will be removed from the cart but can be re-added from the Vouchers listing.</p>
                                <button onClick={() => handleAddMore()} className='modalbtn outlineBlack'> + Add More</button>
                                <button className='modalbtn actibtn' onClick={() => handleActivate()}>{offerCards?.length === 1 ? "Activate" : "Activate All"} </button>
                            </div>
                        </>
                    ) : (
                        <div className="cartdv">
                            <svg width="60" height="71" viewBox="0 0 60 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 16.9997C20 11.4768 24.477 6.99967 30 6.99967C35.523 6.99967 40 11.4768 40 16.9997H20ZM13.3333 16.9997H3.33333C1.4924 16.9997 0 18.4921 0 20.333V66.9997C0 68.8407 1.4924 70.333 3.33333 70.333H56.6667C58.5077 70.333 60 68.8407 60 66.9997V20.333C60 18.4921 58.5077 16.9997 56.6667 16.9997H46.6667C46.6667 7.79494 39.2047 0.333008 30 0.333008C20.7953 0.333008 13.3333 7.79494 13.3333 16.9997ZM20 30.333C20 35.856 24.477 40.333 30 40.333C35.523 40.333 40 35.856 40 30.333H46.6667C46.6667 39.5377 39.2047 46.9997 30 46.9997C20.7953 46.9997 13.3333 39.5377 13.3333 30.333H20Z" fill="#DDDDDD" />
                            </svg>
                            <h3>Nothing in your cart yet!</h3>
                            <p>You can add multiple food offers in your cart</p>
                            <Link to="/food-Vouchers-at-boxoffice" className='btnround'>Start Exploring!</Link>
                        </div>
                    )}
                </section>
            </div>

            {offerCards?.length > 1 &&
                <Modal className='slideTopModal clrcart'
                    show={isClosing}
                    onHide={handleHide}
                    animation={false}
                    keyboard={false}
                    dialogClassName={isClosing ? "modal-dialog modal-hide" : "modal-dialog"}
                    style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
                >
                    <div className="modalbody">
                        <h3 className='rdmTitle'>Are you sure you want to clear all vouchers?</h3>
                        <div className="fdrdmbtn">
                            <button className='modalbtn offermdbtn addtocartbtn' onClick={handleHide}>Cancel</button>
                            <button className='modalbtn offermdbtn actibtn' onClick={handleConfirm}>Yes</button>
                        </div>
                    </div>
                </Modal>
            }
            <SweetAlertUtility type={alertDetails.type} title={alertDetails.title} message={alertDetails.message} show={alertDetails.show} onConfirm={hideAlert} />
        </>
    )
}

export default FoodCart
